import React, { useState, useEffect } from 'react';

const KonamiCodeHandler = ({ onActivate }) => {
  const [sequence, setSequence] = useState([]);
  const [isActivated, setIsActivated] = useState(false);
  
  const konamiCode = [
    'ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown',
    'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight',
    'KeyB', 'KeyA'
  ];

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (isActivated) return;
      
      const newSequence = [...sequence, event?.code];
      
      // Keep only the last 10 keys
      if (newSequence?.length > konamiCode?.length) {
        newSequence?.shift();
      }
      
      setSequence(newSequence);
      
      // Check if the sequence matches the Konami code
      if (newSequence?.length === konamiCode?.length) {
        const matches = newSequence?.every((key, index) => key === konamiCode?.[index]);
        
        if (matches) {
          setIsActivated(true);
          onActivate();
          
          // Show success message
          console.log('🎉 Konami Code Activated! Professional mode unlocked!');
          
          // Reset after some time
          setTimeout(() => {
            setIsActivated(false);
            setSequence([]);
          }, 30000);
        }
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [sequence, konamiCode, isActivated, onActivate]);

  // Visual feedback for sequence progress
  const progress = (sequence?.length / konamiCode?.length) * 100;

  return (
    <>
      {sequence?.length > 0 && !isActivated && (
        <div className="fixed bottom-4 right-4 z-50">
          <div className="bg-card border border-primary rounded-lg p-3 terminal-glow">
            <div className="flex items-center space-x-2">
              <div className="text-xs text-muted-foreground font-source">
                Secret sequence: {sequence?.length}/{konamiCode?.length}
              </div>
              <div className="w-16 bg-muted rounded-full h-1">
                <div 
                  className="bg-primary h-1 rounded-full transition-all duration-300"
                  style={{ width: `${progress}%` }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {isActivated && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/90 backdrop-blur-sm">
          <div className="bg-card border border-primary rounded-lg p-8 terminal-glow-strong text-center max-w-md">
            <div className="text-4xl mb-4">🎉</div>
            <h3 className="text-xl font-fira text-primary mb-2">
              Professional Mode Activated!
            </h3>
            <p className="text-muted-foreground text-sm font-source mb-4">
              You've discovered the secret! The real portfolio is revealed.
            </p>
            <div className="text-xs text-muted-foreground font-source">
              This would transform the entire interface into a polished, professional portfolio...
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default KonamiCodeHandler;